module.exports = __webpack_public_path__ + "img/track_cross_country.6e8dabd2.svg";